module.exports = __webpack_public_path__ + "static/img/icon8-12.7b7fd6d4.png";